import { Box, Divider, Stack, Typography } from "@mui/material";
import { ArrowSmallRight } from "react-swm-icon-pack";
import OutlinedButton from "@/components/common/buttons/outlinedButton";
import MedspaContactInfo, {
  MedspaContactInfoProps,
} from "@/components/common/footer/medspaContactInfo";
import ContentContainer from "@/components/common/pageContainer/contentContainer";
import AffirmPolicy from "@/components/common/paymentPlans/affirmPolicy";
import { PoweredByMoxie } from "@/components/common/powerByMoxie/powerByMoxie";
import { GREY, TEXT_SECONDARY } from "@/config/mui/colorPalette";

type MedspaFooterProps = {
  medspaSlug: string;
  additionalAction?: {
    buttonText: string;
    onClick: () => void;
  };
  affirmEnabled: boolean;
};

export default function MedspaFooter({
  medspaSlug,
  additionalAction,
  affirmEnabled,
  ...props
}: MedspaFooterProps & MedspaContactInfoProps) {
  return (
    <Box
      sx={{
        left: 0,
        bottom: 0,
        width: "100%",
        backgroundColor: GREY[10],
      }}
    >
      <ContentContainer maxWidth="lg-client" sx={{ py: 0 }}>
        <Stack
          sx={{
            mt: 6,
            gap: 2.5,
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h1">Let&apos;s meet together</Typography>
            <Typography
              sx={{
                color: TEXT_SECONDARY,
              }}
            >
              We&apos;re here to help you look and feel your best! Schedule your
              session today.
            </Typography>
          </Box>
          {additionalAction && (
            <OutlinedButton
              small
              onClick={additionalAction.onClick}
              withIcon={false}
              text={additionalAction.buttonText}
              endIcon={
                <ArrowSmallRight color={props.customizationPrimaryColor} />
              }
              sx={{ m: 0, width: "fit-content" }}
            />
          )}
        </Stack>
        <MedspaContactInfo {...props} />
        {affirmEnabled && <AffirmPolicy />}

        <Divider />
        <PoweredByMoxie medspaSlug={medspaSlug as string} />
      </ContentContainer>
    </Box>
  );
}
